import { createFileRoute } from "@tanstack/react-router";
import BiometricsFlow from "@/features/assessments/pages/biometrics/BiometricsFlow";

export const Route = createFileRoute("/$locale/$partner/_evaluation/biometrics")({
	component: BiometricsFlow,
});
